import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCustomHoneymoon = loadable(() => import(/* webpackChunkName: "guest/stays-page-honeymoon-custom" */ './CustomHoneymoon'), 'CustomHoneymoon');
